import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useField } from 'formik'

import { Box, Text } from '@redriverpress/system'

import CheckboxField from './CheckboxField'
import ErrorWrapper from './ErrorWrapper'

const StyledExtraContent = styled(Text).attrs(() => ({
  as: 'span',
}))`
  display: block;
  cursor: default;
  /* aligns content with the label text above: width of checkbox + side padding */
  padding-left: calc(24px + ${props => props.theme.space[2]});
`

/**
 * Checkbox with boolean value. The main difference with
 * CheckboxField component is that it's displayed on
 * a box with background color and that it show error
 * messages (outside the box with bg).
 */
function Agreement({ label, children, mb, bg, hideOutline, ...props }) {
  const fieldContext = useField(props)

  const { touched, error } = fieldContext[1]

  return (
    <Box mb={mb}>
      <Box bg={bg} borderRadius='rounded' p={3}>
        <CheckboxField
          label={label}
          labelPadding={3}
          mb={0}
          small
          hideOutline={hideOutline}
          {...props}
        />
        <StyledExtraContent>{children}</StyledExtraContent>
      </Box>
      {touched && error && <ErrorWrapper>{error}</ErrorWrapper>}
    </Box>
  )
}

Agreement.defaultProps = {
  label: null,
  children: null,
}

Agreement.propTypes = {
  bg: PropTypes.string,
  children: PropTypes.node,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  mb: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  name: PropTypes.string.isRequired,
  hideOutline: PropTypes.bool,
}

Agreement.defaultProps = {
  id: '',
  mb: 3,
  bg: 'blue100',
  hideOutline: true,
}

export default Agreement
